import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// lodash
import includes from 'lodash/includes';
// jl-design-system
import Message from 'jl-design-system/components/message/Message';
// redux
import { connect } from 'react-redux';
// components
import MyAccountLink from '../my-account-link/MyAccountLink';
// constants
import paymentTypeConstants from '../../constants/paymentTypeConstants';
// utils
import addSpacesToPDCN from '../../utils/helpers/partnerDiscountNumberFormatter';

import styles from './partner-discount-invalid-message.scss';

export class PartnerDiscountInvalidMessage extends PureComponent {
  static propTypes = {
    isPosCreditPaymentTypeSelected: PropTypes.bool,
    partnerDiscountCardNumber: PropTypes.string,
  };

  static defaultProps = {
    isPosCreditPaymentTypeSelected: false,
    partnerDiscountCardNumber: '',
  };

  render() {
    const {
      isPosCreditPaymentTypeSelected,
      partnerDiscountCardNumber,
    } = this.props;

    const formattedPartnerDiscountCardNumber = addSpacesToPDCN(partnerDiscountCardNumber);

    return (
      <Message
        animation="shake"
        body={(
          <>
            <p>
              <strong>
                {formattedPartnerDiscountCardNumber}
              </strong> is either wrong,
              suspended or expired.
            </p>
            <p>
              You can place the order without discount or enter a
              valid Partner Discount number by going to <MyAccountLink />.
              {
                isPosCreditPaymentTypeSelected &&
                <span> We have cancelled your payment plan with Creation Consumer Finance Ltd.</span>
              }
            </p>
          </>
        )}
        className={styles.message}
        code="client.delivery.message"
        data-test="partner.discount.invalid.error.message"
        title="Your Partner Discount number is not valid"
        type="error"
      />
    );
  }
}

export function mapStateToProps(state) {
  return {
    isPosCreditPaymentTypeSelected: includes(state.payment.selectedPaymentType, paymentTypeConstants.POS_CREDIT),
    partnerDiscountCardNumber: state.user.partnerDiscountCardNumber,
  };
}

export default connect(state => mapStateToProps(state))(PartnerDiscountInvalidMessage);
